// extracted by mini-css-extract-plugin
export default {"thumbnail":"Thumbnail_thumbnail__seJkn","flexContainer":"Thumbnail_flexContainer__GlB4E","imageShowBox":"Thumbnail_imageShowBox__FIqcW"};